/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment, useCallback, useRef } from 'react'
import InputBox from '../../components/InputBox'
import ErrorMessage from '../../components/ErrorMessage'
import TextArea from '../../components/TextArea'
import TopHeader from '../../components/TopHeader'
import { useState ,useContext,useEffect} from 'react'
import { useNavigate ,useParams,useLocation} from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import GlobalContext from '../../components/Context/GloablContext'
import Debounce from '../../CommonMethods/Debounce'
import { Link } from 'react-router-dom'

import { validateEmail } from '../../CommonMethods/EmailValidator'
import { useGetUserQuery,useEditUserMutation,useAddUserMutation, useUpdateEmailMutation,useLazyGetUserQuery } from '../../features/apiSlice'
import CustomOverLay from '../../components/CustomOverLay'
import { motion } from 'framer-motion'
import AnimatedModel from '../../components/Animation/AnimatedModel'
import Loader from '../../components/Loader'
import { handleClear, handleIsAPICall } from '../../redux/commonSlice'
import ConfirmationPrompt from '../../components/ConfirmationPrompt'
import SearchEmptyScreen from '../../components/SearchEmptyScreen'
import DropdownWithSearchForSubDiv from './Dropdowns/dropdownWithSearchforSubDiv'
import OrganizationDropdownCorpWithSearch from './Dropdowns/dropdownWithSearchForOrg'
import { popFromSubDivArray, pushToSubDivArray, resetSubDivList, toggleSubDivRowSelection } from './subdivisionSlice'
import { convertEpochToDateFormat } from '../../CommonMethods/DateConversion'
import PhoneNumberValidator from '../../components/PhoneNumberInput'
import { phoneCodeArray } from '../../CommonMethods/phoneNumberCountryCodes'
import { handleIsViewScreen } from '../../redux/systemConfigSlice'
import { BeatLoader } from 'react-spinners'
import { handleEditMessageSent,handleTargetUserEditId } from '../../redux/systemConfigSlice'
import { userService } from '../../services/user.services'
import { broadcastForcedLogout } from '../../CommonMethods/authSession'
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
import { useAdminOrCorporateSearch } from '../../components/Context/adminCorporateSearch'

export default function AddAdminUser({edit}) {

    const [editUser]=useEditUserMutation()
    const [addUser] = useAddUserMutation()
    const [updateEmail] = useUpdateEmailMutation()
    const dispatch=useDispatch()
    const location=useLocation()
    const [trigger , result] = useLazyGetUserQuery()

    const isFromEdit = location.state?.[1] || false;
    const originalListingState = Array.isArray(location.state) ? (location.state[0] ?? '') : (location.state ?? '')
    const auth=useSelector(state=>state?.auth)
    
    const userArr=useSelector(state=>state?.subdivSelect?.subdivData?.checkedArr)
    
    //const dataArr=useSelector(state=>state.userSelect.selectedUsers.data)
    
    //const [subTrigger,subresult]=useLazyGetSubDivQuery()
    

    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
    const [addUserDetails,setAddUserDetails]=useState({
        "admin":userType==="admin-user"?false:true,
        "user_name":"",
        "first_name":"",
        "last_name":"",
        "email_addr":"",
        "mobile_number":"",
        "main_number":"",
        'address':"",
    })
    
    const {id}=useParams()
    const containerRef = useRef(null);
    const [skip,setSkip]=useState(true)
    const {data,isFetching,status}=useGetUserQuery(id,{skip:skip})
    const [confirmationStateStatus,setConfirmationStateStatus]=useState(false)
    const [isDisableCancel,setIsDisableCancel]=useState(true)
    const {confirmationStateCancel,setConfirmationStateCancel,confirmationState,setConfirmationState, setToastmessage,setToastErrorMessage ,isSideBar,editSocket,setEditSocket,sendMessageToStopEditing,sendMessageToStartEditing,setIsAdvancedSearchOpen} = useContext(GlobalContext)
    const { resetAdvancedAdminCorSearch } = useAdminOrCorporateSearch();
    const [subDivisionDataLoading,setSubDivisionDataLoading]= useState(false)
    const [isOpen,setIsOpen] = useState(false)
    const [isSubdivOpen,setIsSubdivOpen] = useState(false)
    const [emptyField, setEmptyField] = useState(false)
    const [dataloading,setDataLoading] = useState(true)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('');
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    const [emailError,setEmailError]=useState({
        "email_error":false,
        "text":false,
        "username_error":false
    })
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({"mobile_number":true,"main_number":true});
    const [isFetchData,setIsFetchData] = useState(true)

    const [selectedOrganizationName, setSelectedOrganizationName] = useState([{
        organization_name: '',
        organization_id: '',
        orgIndex:''
    }]);

 
    
    const [loading,setLoading]=useState(false)
    const [emailButtonLoading,setEmailButtonLoading]=useState(false)

    const navigate=useNavigate()

    const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
 
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const messageSent=useSelector(state=>state?.systemConfigData?.messageSent)
    const [countryCodeVal,setCountryCodeVal]=useState('')
    const [countryCodeVal2,setCountryCodeVal2]=useState('')
    const [statusToggle,setStatusToggle]=useState(false)
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [emptyArea,setEmptyArea]=useState(false);
    const [usernameError,setUsernameError]=useState(false)
    const [loadingStatus,setLoadingStatus]=useState(false)
    const [submitSelected,setSubmitSelected]=useState(false);
    const [emailVefiedButton,setEmailVeriedButton]=useState(true);
    const [nextTarget, setNextTarget] = useState('');
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingTop, setIsLoadingTop] = useState(false);
     

    function handleOnChangeUserDetails(id,option){
        setSubmitSelected(false)
        setEmailError({
            text:false,
            email_error:false,
            username_error:false
        })
        const fieldToUpdate = {
            admin:"admin",
            corporate:"corporate",
            user_name:"user_name",
            first_name:"first_name",
            last_name:"last_name",
            email_addr:"email_addr",
            mobile_number:"mobile_number",
            main_number:"main_number",
            address:"address"
           
        }[id];
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid=true

        if (id === "mobile_number" || id==="main_number") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid=false
            }
        }
        if(!isValid){
            if (fieldToUpdate) {
                setAddUserDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption
                }));
            }             
            return
        }
        if(fieldToUpdate){
            fieldToUpdate!=="admin"&& setIsDisableCancel(false)
            if(fieldToUpdate==="admin"){
                if(!edit){
        
                    setAddUserDetails((prev)=>({
                        ...prev,
                        "user_name":"",
                        "first_name":"",
                        "last_name":"",
                        "email_addr":"",
                        "mobile_number":"",
                        "main_number":"",
                        'address':"",
                    }))
                    dispatch(resetSubDivList())
                    setSelectedOrganizationName([{
                        organization_name: '',
                        organization_id: '',
        
                    }])
                    setEmptyField(false)
                    setUsernameError(false)
                    setEmailError({
                        "email_error":false,
                        "username_error":false
                    })
                    setCountryCodeVal('')
                    setCountryCodeVal2('')
                }
                setIsPhoneNumberValid({
                    "main_number":true,
                    "mobile_number":true
                })
                setAddUserDetails((prev) => ({
                    ...prev,
                    "admin": !addUserDetails.admin,
                }));
            }
            else if(fieldToUpdate==="mobile_number"||fieldToUpdate==="main_number"){
                if(option?.length<=20){
                    setAddUserDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if(fieldToUpdate==="first_name"||fieldToUpdate==="last_name"){
                if(option?.length<=30){
                    setAddUserDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));

                }

            }
            else if(fieldToUpdate==="email_addr"||fieldToUpdate==="user_name"){
                setUsernameError(false)
                setEmailVeriedButton(true)
                setEmailButtonLoading(false)
                if(option?.length<=80){
                    if(!edit&&fieldToUpdate==='user_name'){
                        setAddUserDetails((prev) => ({
                            ...prev,
                            [fieldToUpdate]: option.replace(/\s/g, ''),
                            email_addr:option.replace(/\s/g,'')
                        }));
                    }
                    else{
                        setAddUserDetails((prev) => ({
                            ...prev,
                            [fieldToUpdate]: option.replace(/\s/g, ''),
                        }));
                    }
                    

                }
            }
            else{
                setAddUserDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }
            
        }

    }
    // const handlePhoneNumberValidationChange = (isValid) => {
    //     setIsPhoneNumberValid(isValid);
    // };

    
    
    useEffect(()=>{
    
        (selectedOrganizationName?.length>0&&selectedOrganizationName?.[0]?.organization_id!==''&&items?.length===0)?fetchData():''
    },[selectedOrganizationName])

    useEffect(() => {
        if (edit) {
            if (userType !== 'corporate-user') {
                setQueryParamsadmin('type=admin-edit-corporate-user');
            } else {
                setQueryParamsadmin('type=admin-edit-corporate-user');
            }
        } else {
            if (userType !== 'corporate-user') {
                setQueryParamsadmin('type=admin-add-corporate-user');
            } else {
                setQueryParamsadmin('type=admin-add-corporate-user');
            }
        }
    }, [userType,edit]);

    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);


    const handleRemoveOrgField = (indexToRemove,orgIndex) => {
        setIsSubdivOpen(false)
        setIsOpen(false)
        setEmptyField(false);
        dispatch(popFromSubDivArray([indexToRemove]))
        setToastErrorMessage('')
        const updatedOrgFields = selectedOrganizationName.filter((_, index) => index !== indexToRemove); 
        setSelectedOrganizationName(updatedOrgFields);
        if(edit){
            const updatedItems = items.filter((item, index) => item?.orgIndex !== orgIndex); 
            setItems(updatedItems);
            setPage(prev=>prev-1)
        }
    
    };

    const handleAddOrgField = () => {
        setIsSubdivOpen(false)
        setIsOpen(false)
        setIsFetchData(false)
        dispatch(pushToSubDivArray(['']))
        setEmptyField(false);
       
        setToastErrorMessage('')
       
        const updatedOrgNameFields=[
            ...selectedOrganizationName,
            {organization_name:'',organization_id:'',orgIndex:selectedOrganizationName?.length}
        ]
        setSelectedOrganizationName(updatedOrgNameFields)
        const updatedItems=[
            ...items,
            {organization_name:'',organization_id:'',orgIndex:selectedOrganizationName?.length}
        ]
        setItems(updatedItems)
        setPage(prevPage=>prevPage+1)
        // if (selectedOrganizationName.length === 19)  {
        //     setToastErrorMessage('')
        // }
    };
    function handleSubmit(){
      
        setSubmitSelected(true)
        const hasEmptyFields = () => {
            // const areFieldsEmpty = newOrgFields.some(field => field.organizations.trim() === '' || field.sub_divisions === '');
            let isFieldsEmpty=false
            if(addUserDetails.first_name.trim()===""||addUserDetails.main_number.trim()===""||addUserDetails.user_name.trim()===""||addUserDetails.email_addr.trim()===""||(addUserDetails?.admin!==true&&selectedOrganizationName?.some(obj => obj.organization_id === ''))||(addUserDetails?.admin!==true&&userArr?.length===0)||(addUserDetails?.admin!==true&&userArr?.some(arr=>arr?.every((item)=>item.isChecked===false)))){
                isFieldsEmpty=true
            }
            
            // return (!addUserDetails.admin&&areFieldsEmpty) || isFieldsEmpty;
            return isFieldsEmpty
        };
        if (hasEmptyFields()) {
           
            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        }
        if(validateEmail(addUserDetails?.user_name?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "text":true,
                "username_error":true
            }))
            if(addUserDetails?.email_addr?.trim()!==""&&validateEmail(addUserDetails?.email_addr?.trim())) {  
                setEmailError((prev)=>({
                    ...prev,
                    "text":true,
                    "email_error":true
                }))
               
            }
            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return
        }
        if(addUserDetails?.email_addr?.trim()!==""&&validateEmail(addUserDetails?.email_addr?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "text":true,
                "email_error":true
            }))
            setLoading(false);
            return
        }
        if ((!(isPhoneNumberValid.main_number)&&addUserDetails?.main_number!=='') || (!(isPhoneNumberValid.mobile_number)&&addUserDetails?.mobile_number!=='')) {
            // Delay showing the toast message until isPhoneNumberValid is updated
            setLoading(false);
            return;
        }

    
        setConfirmationState(true)
    }
    const handleOnAddUser=async()=>{
       
        
        try {
            setLoading(true)
            let response = null
            let body={}
            edit?body={
                "user_name":addUserDetails.user_name,
                "user_id":result?.data?.user_id,
                "first_name": addUserDetails.first_name,
                "last_name": addUserDetails.last_name,
                // "email_address": addUserDetails.email_addr.trim().replace(/\s/g, ''),
                "mobile_number": addUserDetails.mobile_number,
                "main_number": addUserDetails.main_number,
                "user_type": addUserDetails.admin?"admin-user":"corporate-user",
                "country_code1": "+"+(countryCodeVal!==""?countryCodeVal.split('\t').join('')?.trim():country_code.split('\t').join('')?.trim()),
                "country_code2": "+"+(countryCodeVal2!==""?countryCodeVal2.split('\t').join('')?.trim():country_code.split('\t').join('')?.trim())

            }:body = {
                "user_name":addUserDetails.user_name,
                "first_name": addUserDetails.first_name,
                "last_name": addUserDetails.last_name,
                // "email_address": addUserDetails.user_name,
                "mobile_number": addUserDetails.mobile_number,
                "main_number": addUserDetails.main_number,
                "user_type": addUserDetails.admin?"admin-user":"corporate-user",
                "country_code1": "+"+(countryCodeVal!==""?countryCodeVal.split('\t').join('')?.trim():country_code.split('\t').join('')?.trim()),
                "country_code2": "+"+(countryCodeVal2!==""?countryCodeVal2.split('\t').join('')?.trim():country_code.split('\t').join('')?.trim())
            }
            if(!addUserDetails.admin){
                
                edit?body={
                    "user_name":addUserDetails.user_name,
                    "user_id":result?.data?.user_id,
                    "first_name": addUserDetails.first_name,
                    "last_name": addUserDetails.last_name,
                    // "email_address": addUserDetails.email_addr.trim().replace(/\s/g, ''),
                    "mobile_number": addUserDetails.mobile_number,
                    "main_number": addUserDetails.main_number,
                    "user_type": addUserDetails.admin?"admin-user":"corporate-user",
                    "address":addUserDetails.address,
                    "country_code1": "+"+(countryCodeVal===""?country_code.split('\t').join('')?.trim():countryCodeVal.split('\t').join('')?.trim()),
                    "country_code2": "+"+(countryCodeVal2===""?country_code.split('\t').join('')?.trim():countryCodeVal2.split('\t').join('')?.trim()),
                    "organizations":  selectedOrganizationName?.map((item,index)=>(item?.organization_id!==''&&userArr[index]?.length!==0&&{'organization_id':item?.organization_id,"sub_divisions":userArr[index]?.filter((subdiv)=>subdiv?.isChecked===true)?.map((item)=>item?.id)}))?.filter(value => typeof value !== 'boolean')
                }:body={
                    "user_name":addUserDetails.user_name,
                    "first_name": addUserDetails.first_name,
                    "last_name": addUserDetails.last_name,
                    // "email_address": addUserDetails.user_name,
                    "mobile_number": addUserDetails.mobile_number,
                    "main_number": addUserDetails.main_number,
                    "user_type": addUserDetails.admin?"admin-user":"corporate-user",
                    "address":addUserDetails.address,
                    "country_code1": "+"+(countryCodeVal===""?country_code.split('\t').join('')?.trim():countryCodeVal.split('\t').join('')?.trim()),
                    "country_code2": "+"+(countryCodeVal2===""?country_code.split('\t').join('')?.trim():countryCodeVal2.split('\t').join('')?.trim()),
                    "organizations": selectedOrganizationName?.map((item,index)=>(item?.organization_id!==''&&userArr[index]?.length!==0&&{'organization_id':item?.organization_id,"sub_divisions":userArr[index]?.filter((subdiv)=>subdiv?.isChecked===true)?.map((item)=>item?.id)}))?.filter(value => typeof value !== 'boolean')
                }
            }
            if(edit){
                const editRes=await editUser({id,body})
                if(editRes?.error?.data?.message==="Email Address must be a valid email address"){
                    setConfirmationState(false)
                    setEmailError((prev)=>({
                        ...prev,
                        "text":true,
                        "email_error":true
                    }))  
                    setLoading(false);                  
                }
                else if(editRes?.error?.data?.message){
                    setConfirmationState(false)
                    setToastErrorMessage(editRes?.error?.data?.message)
                    setLoading(false)
                }
                else{
                    let status=result?.data?.status==="inactive"?false:true
                    if(statusToggle!==status){
                        const statusRes=await editUser({ "user_name":[addUserDetails?.user_name],status:status==="inactive"?"active":"inactive"})
                    
                    }
                    setConfirmationState(false)
                    // For edit, preserve the original state (no need to reset page number)
                    navigate(`/manage-admin-corporate/${id}`,{state:edit?originalListingState:''})
                    setToastmessage(`${addUserDetails?.admin?'Admin User updated successfully':'Corporate User updated successfully'}`);
                    setLoading(false)
                    

                }
                
            }
            else{
                const addRes=await addUser(body)

                if(addRes?.error?.data?.message==="Email Address must be a valid email address"){
                    setConfirmationState(false)
                    setEmailError((prev)=>({
                        ...prev,
                        "text":true,
                        "email_error":true
                    })) 
                    setLoading(false);                  
                   
                }
                else if(addRes?.error?.data?.message){
                    setToastErrorMessage(addRes?.error?.data?.message)
                    setLoading(false)
                    if(addRes?.error?.data?.message==="Username already exists. Please try another"){
                        setConfirmationState(false)
                        setUsernameError(true)
                    }
                }
                else{
                    setConfirmationState(false)
                    // Update the state to set page_number to 1 while preserving other pagination settings
                    const updatedState = {
                        ...originalListingState,
                        page_number: '1'
                    };
                    navigate(`/manage-admin-corporate/${addRes?.data?.user_id}`, { state: updatedState })
                    setToastmessage(addRes?.data?.message);
                    setLoading(false)
                    setIsAdvancedSearchOpen(false)
                    resetAdvancedAdminCorSearch()
                }
               
            }
            setIsDisableCancel(true)
           
           
           
        } catch (error) {
            setLoading(false); 
            setToastErrorMessage(error.message)   
        }

    }
    useEffect(()=>{
        if(id){
            trigger(id)      
        }  
           
    },[id])
    
    
    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) {
                    return; // Prevent multiple logout calls
                }else if (event.data === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    broadcastForcedLogout();
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                    setTimeout(() => {
                        window.location.reload();
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    
    useEffect(()=>{
        if(result!==undefined&&result?.data?.user_id!==undefined){
            if(userType==='admin-user'&&result?.user_type==='admin-user'){
                navigate('/manage-admin-corporate', {state: originalListingState})
                return
            }
            dispatch(handleTargetUserEditId(result?.data?.user_id))
            if(edit&&!messageSent&&editSocket){
               
                sendMessageToStartEditing(result?.data?.user_id)
                let message
                editSocket.onmessage = (event) =>{
                    message = event.data
                    if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                        setDataLoading(false)
                    } else{
                        dispatch(handleEditMessageSent(false))
                        navigate('/manage-admin-corporate', {state: originalListingState})
                        { (JSON.parse(message)?.adminId) &&
                            setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this user`)
                        }
                    }
                }    
            }else{
                setDataLoading(false)
            }
            setDataLoading(false)


            setAddUserDetails((prev)=>({
                ...prev,
                "admin":result?.data?.user_type==="admin-user"?true:false,
                "user_name":result?.data?.user_name,
                "first_name":result?.data?.first_name,
                "last_name":result?.data?.last_name,
                "email_addr":result?.data?.email_address,
                "mobile_number":result?.data?.mobile_number,
                "main_number":result?.data?.main_number,
                'address':result?.data?.address,
            }))
            setStatusToggle(result?.data?.status==="inactive"?false:true)
            setSkip(true)
        }
        if(result?.data&&result?.status==='fulfilled'&& edit){
            setCountryCodeVal(result?.data?.country_code1.split('+')[1])
            setCountryCodeVal2(result?.data?.country_code2.split('+')[1])
            //const selectedOrgs=data?.organizations_and_subdivisions?.map((item)=>({'organization_id':item?.organization_id,'organization_name':item?.organization_name}))
            const selectedOrgs = Array.from(
                new Set(
                    (result?.data?.organizations_and_subdivisions || []).map((item) => item?.organization_id)
                )
            ).map((organizationId,index) => {
                const matchingItem = result?.data.organizations_and_subdivisions.find(
                    (item) => item.organization_id === organizationId
                );
              
                return {
                    organization_id: organizationId,
                    organization_name: matchingItem?.organization_name,
                    orgIndex:index
                };
            });
            setSelectedOrganizationName(selectedOrgs)
            selectedOrgs?.forEach((obj) => {
                dispatch(pushToSubDivArray(['emptyEdit',result?.data?.organizations_and_subdivisions?.filter(item => item.organization_id === obj?.organization_id)?.map(sub => ({
                    id: sub.subdivision_id,
                    name: sub.subdivision_name,
                    isChecked:true,
                    isEdit:true
                }))]));
            });
          
        
        }
        return(()=>{
            if((location.state===null || location.state==='')){
                sendMessageToStopEditing(result?.data?.user_id)
            }  
        })
     
    },[result])
 
   
    const handleOnCLickActivate = async(e) => {
        // useDispatch(handleIsAPICall(true))
        if(statusToggle===false&& textAreaMsg.trim()===""){ 
            setToastErrorMessage('Please fill in the mandatory field')
        
            setEmptyArea(true)
            
            return;
        }
        try {
            let body = { }
            if(statusToggle===false){
                body={
                    "user_name": [addUserDetails.user_name],
                    "status":"inactive",
                    "note" : textAreaMsg 
                } 
            }
            else{
                body={
                    "user_name": [addUserDetails.user_name],
                    "status":"active",
                    "note":''
                } 
            }
            
            setLoadingStatus(true)
           
            const activationRes=await editUser({body})
            
            setLoadingStatus(false)
            
            if(activationRes.error){
                setToastErrorMessage(activationRes?.error?.data?.message)
            }else{
                setToastmessage(`${addUserDetails.admin?'Admin ':'Corporate '}user ${statusToggle===true?"activated":"deactived"} successfully`);
                
            }
            setConfirmationStateStatus(false);
            setTextAreaMsg('');
           
        } catch (error) {
            setConfirmationStateStatus(false);
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }   
    
    const handleConformationClick = () => {
        setEmptyArea(false)
        setStatusToggle(!statusToggle)
        setTextAreaMsg("")
        setConfirmationStateStatus(false);
    }

    useEffect(()=>{
        dispatch(resetSubDivList())
        return(()=>{
            if(location?.state!==null||location?.state!==''){
                sendMessageToStopEditing()
            }
        })
       
    },[])

    const handleOnVerifyEmail=async()=>{
            
           
        if(addUserDetails?.email_addr?.trim()!==""&&validateEmail(addUserDetails?.email_addr?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "text":true,
                "email_error":true
            }))

            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return
               
        }
        try {
            setEmailButtonLoading(true)
            let response = null
            let body={}
            body={
                "user_type":"admin-user",
                "email_address": addUserDetails.email_addr.trim().replace(/\s/g, ''),
            }
            if(!addUserDetails.admin){
                body={
                    "user_type":"corporate-user",
                    "email_address": addUserDetails.email_addr.trim().replace(/\s/g, ''),
                }
            }
            const emailVerifyRes=await updateEmail({id,body})

            if(emailVerifyRes?.error?.data?.message==="Email Address must be a valid email address"){
                setEmailError((prev)=>({
                    ...prev,
                    "text":true,
                    "email_error":true
                })) 
                setEmailButtonLoading(false)
            }
            else if(emailVerifyRes?.error?.data?.message){
                setConfirmationState(false)
                setToastErrorMessage(emailVerifyRes?.error?.data?.message)
                setEmailError((prev)=>({
                    ...prev,
                    text:false,
                    "email_error":true
                })) 
                setEmailButtonLoading(false)
            }
            else{
                setToastmessage(emailVerifyRes?.data?.message);
                setEmailButtonLoading(false)   
                setEmailVeriedButton(false)
            }
            setIsDisableCancel(true)
        } catch (error) {
            setLoading(false); 
            setToastErrorMessage(error.message)   
        }

    }
    // for cancel botton
    const handleClosebotton = () => {
        if (isDisableCancel && (isFromEdit===true)) {
            navigate(`/manage-admin-corporate/${id}`, {state: originalListingState});
        } else if (isDisableCancel) {
            navigate('/manage-admin-corporate',{ state: originalListingState });
        } else {
            setNextTarget(
                (isFromEdit===true)
                    ? 'view'
                    : 'list'
            );
            setConfirmationStateCancel(true);
        }    
        
        // if (!isDisableCancel) {
        //     setConfirmationStateCancel(true);
        // } else {
        //     navigate('/manage-admin-corporate');
        // }
    };
    // for cancel the changes
    const handleClickActivate = () => {
        if (confirmationState) {
            handleOnAddUser();
        } else {
            setIsDisableCancel(true);
            setConfirmationStateCancel(false);
            if (nextTarget === 'view') {
                navigate(`/manage-admin-corporate/${id}`, {state: originalListingState});
            } else {
                navigate('/manage-admin-corporate', { state: originalListingState });
            }
        }
    };


    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isLoading]);

    const fetchData = async(isInitial) => {
        items?.length>=20?(setIsLoadingTop(true),setIsLoading(true)):''
        const res = selectedOrganizationName?.slice(page,page+10)
        if (page===selectedOrganizationName?.length) return;
        if (res?.length === 0) {
            setIsLoading(false)
            
            // No more data available
        }
        
        else{
            if(items?.length>=20&&res?.length===10){
                setItems(prevItems=>[...prevItems.slice(10,prevItems?.length),...res])
                setPage(prevPage => prevPage + 10);
                if (containerRef.current&&res?.length===10&&items?.length>10) {
                    containerRef.current.scrollTop -= 1050; // Adjust this value as needed
                }
            
            }else{
                setItems(prevItems=>[...prevItems,...res])
                setPage(prevPage => prevPage + res?.length);
                if (containerRef.current&&res?.length===10&&items?.length>10) {
                    containerRef.current.scrollTop -= 1050; // Adjust this value as needed
                }
            }
        
        }     
    }; 
  
    const fetchAboveData = async() => {
        ((items?.[items?.length-1]?.orgIndex!==selectedOrganizationName?.[selectedOrganizationName?.length-1]?.orgIndex))?(setIsLoading(true),setIsFetchData(true)):''
        let res
        if(items?.length===20){
            res = (page-30)>=0?(selectedOrganizationName?.slice(page-30,page-20)):[]
        }
        else if(items?.length!==20){
            res = page-items?.length-10>=0?(selectedOrganizationName?.slice(page-items?.length-10,page-items?.length)):[]
        }
        if (res?.length === 0||res?.length!==10) {
            setIsLoadingTop(false)
            // No more data available
        }
        else{
            setIsLoadingTop(true)
            if(items?.length>=20&&res?.length===10){
                setItems(prevItems=>[...res,...prevItems.slice(0,prevItems?.length-10)])
                setPage(prevPage => prevPage - 10);
                if (containerRef.current&&items?.length>10) {
                    containerRef.current.scrollTop += 1050; // Adjust this value as needed
                }
            
            }else{
                setItems(prevItems=>[...res,...prevItems])
                setPage(prevPage => prevPage - res?.length);
                if (containerRef.current&&items?.length>10) {
                    containerRef.current.scrollTop += 1050; // Adjust this value as needed
                }
            }
        
        }  
       
    }; 

    const handleScroll = Debounce(() => {
        if(document.getElementById('device_scrollarea').scrollTop<643){
            (selectedOrganizationName?.length>0&&selectedOrganizationName?.[0]?.organization_id!=='')?fetchAboveData():''

        }else if((document.getElementById('device_scrollarea').scrollTop>=2159)||(items?.length<=10&&(document.getElementById('device_scrollarea').scrollTop>=1134))||((Math.ceil(document.getElementById('device_scrollarea').scrollTop)+Math.ceil(document.getElementById('device_scrollarea')?.clientHeight)) === Math.ceil(document.getElementById('device_scrollarea')?.scrollHeight))||((Math.floor(document.getElementById('device_scrollarea').scrollTop)+Math.floor(document.getElementById('device_scrollarea')?.clientHeight)) === Math.ceil(document.getElementById('device_scrollarea')?.scrollHeight))){
            (selectedOrganizationName?.length>0&&selectedOrganizationName?.[0]?.organization_id!==''&&isFetchData)?(fetchData()):'';
        }else{
            return
        }

    })

    const date=convertEpochToDateFormat(result?.data?.created_at,dateformat)
    return (
        <>
            
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full'>
                <TopHeader title={"Manage Admin/Corporate Users"}/>
                {((edit&&result?.isFetching&&result?.status!=="fulfilled")||(edit&&dataloading))?<CustomOverLay Active text="Loading Admin/Corporate Details..." classKey={`absolute top-0 left-0 z-50 overflowhidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>
                    <div className='bg-white rounded-lg py-[12px] pl-[30px] pr-[10px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className='pr-7'>
                                    <div className='flex items-center mb-5'>
                                        <Link to="/manage-admin-corporate" state={originalListingState}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Admin/Corporate Users</h1>
                                        </Link>
                                        {isFromEdit===true &&<>
                                            <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>

                                            <Link to={`/manage-admin-corporate/${location.state?.[2]}`} state={originalListingState}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Admin/Corporate User</h1>
                                            </Link>
                                        </>}
                                        <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">{`${edit?'Edit ':'Add '}Admin/Corporate User`}</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </div>
                                    {isFromEdit===true ?
                                        <div onClick={handleClosebotton} className='items-center cursor-pointer min-w-max flex'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] pl-3'>Go back to View Admin/Corporate User</span>
                                        </div> 
                                        :    
                                        <div onClick={handleClosebotton} className='flex  cursor-pointer items-center'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                        </div> 
                                    }
                                    <h1 className={`text-xl font-normal text-[#000000] w-full text-center mt-[-23px] ${edit?'xl:ml-0 ml-[100px]':'xl:ml-0 ml-[40px]'} `}>
                                        {`${edit?'Edit ':'Add '}Admin/Corporate User`}
                                    </h1>
                                    <p className='text-end pt-3.5 pb-1'>‘*’ Indicates mandatory field</p>
                                </div>
                                <div id={"device_scrollarea"} ref={containerRef} className={`pr-5 h-customh14 overflow-auto overflow-x-hidden scrollbar_purple bg-white`} onScroll={handleScroll}>
                                    <div className="border border-[#C5C9DA] rounded-lg px-6 2xl:px-[57px] pt-6 pb-6 mb-4">
                                        {!edit&&<>
                                            {userType==='super-admin'&&<p className='text-sm font-semibold text-[#000000] mb-1.5'>Type</p>}
                                            {userType==='super-admin'&&<div className='flex items-center mb-[34px]'>
                                                <div className="p-2">
                                                    <div className="relative custom-radioBlue flex items-center">
                                                        <input id="admin" disabled={(userType==="admin-user")?true:false}type="radio" name="default-radio" checked={addUserDetails?.admin} onChange={()=>{handleOnChangeUserDetails("admin","admin")}}/>
                                                        <label htmlFor="admin" className="text-base font-normal text-[#000] pl-8 w-full cursor-pointer">
                                                            Admin User
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="p-2">
                                                    <div className="relative custom-radioBlue flex items-center" >
                                                        <input id="corporate"  type="radio" name="default-radio" checked={!addUserDetails?.admin} onChange={()=>{handleOnChangeUserDetails("admin","admin")}}/>
                                                        <label htmlFor="corporate" className="text-base font-normal text-[#000] pl-8 w-full cursor-pointer">
                                                            Corporate User 
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>}
                                        </>}
                                        {
                                            edit&&<>
                                                <div className="mt-[6px] bg-[#E7EAF4] rounded-sm px-5 pt-[18px] mb-10">
                                                    <div className="flex -mx-1 flex-wrap">
                                                        <div className="w-1/4 px-1 mb-[20px]">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Type</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {addUserDetails?.admin?"Admin User":"Corporate User"}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/4 px-1 mb-[30px]">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">ID</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {result?.data?.user_id}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/4 px-1 mb-[30px]">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Username</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {addUserDetails?.user_name}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/4 px-1 mb-[30px]">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Created Date</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {date}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        <div className='flex flex-wrap -mx-[18px]'>
                                            {!edit&&<div className={`w-1/3 px-[18px] mb-[32px]`}>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Username*"} 
                                                        placeholder={"Enter Username"}
                                                        id={"user_name"}
                                                        htmlFor={"Admin_Username"}
                                                        value={addUserDetails.user_name}
                                                        emailError={emailError.username_error}
                                                        usernameError={usernameError}
                                                        emptyField={emptyField&&addUserDetails?.user_name?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                    {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '}  message={"Invalid user name"}/>}
                                                </div>
                                            </div>}
                                            <div className='w-1/3 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"First Name*"} 
                                                        placeholder={"Enter First Name"}
                                                        id={"first_name"}
                                                        htmlFor={"Admin_First_Name"}
                                                        value={addUserDetails.first_name}
                                                        emptyField={emptyField&&addUserDetails?.first_name?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-[18px] mb-[35px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Last Name"} 
                                                        placeholder={"Enter Last Name"}
                                                        id={"last_name"}
                                                        htmlFor={"Admin_Last_Name"}
                                                        value={addUserDetails.last_name}
                                                        emptyField={false}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>  
                                            {!edit &&                               
                                                <div className={`w-1/3 px-[18px] mb-[35px]`}>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Email Address*"} 
                                                            placeholder={"Enter Email Address"}
                                                            id={"email_addr"}
                                                            htmlFor={"Admin_Email_Address"}
                                                            value={addUserDetails.user_name}
                                                            disabled={true}
                                                            emptyField={false}
                                                            emailError={emailError.email_error}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                        {emailError.email_error && <ErrorMessage error  message={"Invalid email address"}/>}
                                                    </div>
                                                </div>
                                            }
                                            {edit && <>
                                                <div className={`w-1/3 px-[18px] mb-[35px]`}></div>
                                                <div className={`w-1/3 px-[18px] mb-[35px]`}>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Email Address*"} 
                                                            placeholder={"Enter Email Address"}
                                                            id={"email_addr"}
                                                            htmlFor={"Admin_Email_Address"}
                                                            value={addUserDetails.email_addr}
                                                            emptyField={emptyField&&addUserDetails?.email_addr?.trim()===""}
                                                            emailError={emailError.email_error}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                        {emailError.email_error && <ErrorMessage error  message={emailError?.text&&"Invalid email address"}/>}
                                                    </div>
                                                </div>
                                                {( (result?.data?.email_address !== addUserDetails?.email_addr)) && 
                                                    <div className={`w-2/3 px-[18px] mb-[35px] pt-3.5`}>
                                                        <button type='button'
                                                            id="verify"
                                                            onClick={() => handleOnVerifyEmail()}
                                                            disabled={emailButtonLoading || !emailVefiedButton || addUserDetails?.email_addr?.trim()===""}
                                                            className={`px-4 py-2 text-lg flex items-center justify-center font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[170px]
                                    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                                            {!emailButtonLoading ? "Verify" : <span>{<Loader />}</span>}
                                                        </button>
                                                    </div>
                                                }
                                                
                                                {((result?.data?.email_address === addUserDetails?.email_addr)) && 
                                                    <div className={`w-2/3 px-[18px] mb-[35px] pt-3`}>
                                                        <button type='button'
                                                            id="verified"
                                                            className={`px-4 py-2 flex items-center justify-center text-lg font-semibold text-[#000] rounded-[16px] mt-2.5 w-[170px] cursor-default
                                                        bg-[#C5C9DA] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                                            <span className='w-6 h-6 bg-[#1A883C] rounded-[50%] mr-2.5 flex justify-center items-center'>
                                                                <img src="/images/success_toast.svg" alt="icon" loading='lazy'  className='w-3.5 h-3.5' decoding='async' />
                                                            </span>
                                                            Verified
                                                        </button>
                                                    </div>
                                                }
                                            </>

                                            }
                                            
                                            <div className='w-1/3 px-[18px] mb-[35px]'>
                                                <div className='w-full'>
                                                    
                                                    <PhoneNumberValidator
                                                        label={"Mobile Number"}
                                                        placeholder={"Enter Mobile Number"}
                                                        id={"mobile_number"}
                                                        htmlFor={"Admin_Mobile_Number"}
                                                        value={addUserDetails.mobile_number}
                                                        emptyField={false}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        isCode={true}
                                                        countryCodeList={phoneCodeArray}
                                                        country_code={country_code}
                                                        countryCodeVal={countryCodeVal2}
                                                        isPhoneNumberValid={isPhoneNumberValid.mobile_number}
                                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                        setCountryCodeVal={setCountryCodeVal2}
                                                        submitSelected={submitSelected}
                                                        //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                    />

                                                  
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-[18px] mb-[35px]'>
                                                <div className='w-full'>
                                                  
                                                    <PhoneNumberValidator
                                                        label={"Main Number*"} 
                                                        placeholder={"Enter Main Number"}
                                                        id={"main_number"}
                                                        htmlFor={"Admin_Mobile_Number"}
                                                        value={addUserDetails.main_number}
                                                        emptyField={emptyField&&addUserDetails?.main_number?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        isCode={true}
                                                        countryCodeList={phoneCodeArray}
                                                        country_code={country_code}
                                                        countryCodeVal={countryCodeVal}
                                                        setCountryCodeVal={setCountryCodeVal}
                                                        isPhoneNumberValid={isPhoneNumberValid.main_number}
                                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                        submitSelected={submitSelected}
                                                        //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}

                                                    />
                                                </div>
                                            </div>
                                            {edit&&<div className='w-1/3 px-[18px]'>
                                                <div className='w-full mt-8'>
                                                    <div className="status custom-toggle flex items-center ">
                                                        <p className="text-sm font-normal  text-[#000000] disable_switch  mr-4">
                                                            Status
                                                        </p> 
                                                        <label className="switch" style={{marginLeft: '10px'}}>
                                                            <input type="checkbox" id="user_status" onChange={(e)=>{
                                                                setStatusToggle(!statusToggle),setConfirmationStateStatus(true)
                                                            }} checked={statusToggle} /><span className="slider round"></span>
                                                        </label>
                                                        <p className="text-sm font-normal  text-[#008586] disable_switch ml-3">
                                                            {statusToggle?'Active':'Inactive'}
                                                        </p> 
                                                    </div>
                                                </div>
                                            </div> }
                                            {!addUserDetails.admin&&<div className='w-full flex flex-wrap'>
                                                <div className='w-full px-[18px] mb-[35px]'>
                                                    <TextArea label={'Address'}
                                                        htmlFor={'corporate_user_address'}
                                                        id={'address'}
                                                        value={addUserDetails.address}
                                                        placeholder={'Enter Address'}
                                                        emptyField={false}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>}
                                    
                                            <div className='w-full'>
                                                {!addUserDetails.admin&&isLoadingTop&&edit&&(items[0]?.orgIndex!==selectedOrganizationName?.[0]?.orgIndex)&&<div className="flex justify-center mb-3"><BeatLoader color='#972E4C'/></div>}
                                                <div className='flex flex-wrap'>
                                                    {!addUserDetails.admin&&(edit?items:selectedOrganizationName).map((field,index)=>{const tempIndex=selectedOrganizationName?.findIndex(item=>item?.orgIndex===field?.orgIndex)
                                                        return(<Fragment key={index}>
                                                            <div  className='w-1/3 px-[18px] mb-[35px]'>
                                                       
                                                                <div className='w-full'>
                                                                    <OrganizationDropdownCorpWithSearch
                                                                        label={"Organization Name*"}
                                                                        id={`organization_name`}
                                                                        placeholder={'Select organization name'}
                                                                        disabled={false}
                                                                        setSubDivisionDataLoading={setSubDivisionDataLoading}
                                                                        selectedOrganizationName={selectedOrganizationName}
                                                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                                                        items={items}
                                                                        setItems={setItems}
                                                                        //subTrigger={subTrigger}
                                                                        //subresult={subresult}
                                                                        emptyField={emptyField&&field?.organization_id===''}
                                                                        selectOrgName={edit?items?.[index]?.organization_name:selectedOrganizationName?.[index]?.organization_name}
                                                                        index={edit?tempIndex:index}
                                                                        adminCorpLink={true}
                                                                        edit={edit}
                                                                        isOpen={isOpen}
                                                                        setIsSubdivOpen={setIsSubdivOpen}
                                                                        setisOpen={setIsOpen}
                                                                        optionId={"option_organization_name"}
                                                                    />
                                                            

                                                                </div>
                                                            </div>
                                                    
                                                            <div className='w-1/3 px-[18px] mb-[35px]'>
                                                                <div className='w-full'>
                                                                    <DropdownWithSearchForSubDiv
                                                                        label={"Sub Division Name*"}
                                                                        id={`sub_divisions`}
                                                                        index={edit?tempIndex:index}
                                                                        items={items}
                                                                        setItems={setItems}
                                                                        orgId={selectedOrganizationName[edit?tempIndex:index]}
                                                                        isBlack={(userArr[edit?tempIndex:index]===undefined||userArr?.[edit?tempIndex:index]?.length===0)}
                                                                        placeholder={((userArr[edit?tempIndex:index]===undefined)||userArr?.[edit?tempIndex:index]?.length===0)?'Select sub division names':`${userArr[edit?tempIndex:index]?.filter((item)=>item.isChecked===true)?.length} Selected`}
                                                                        disabled={selectedOrganizationName?.[edit?tempIndex:index]?.organization_name === '' || selectedOrganizationName?.[edit?tempIndex:index]?.organization_name === undefined ? true : false}
                                                                        selectedOrganizationName={selectedOrganizationName}
                                                                        subDivisionDataLoading={subDivisionDataLoading}
                                                                        emptyField={(emptyField&&userArr?.length===0)||emptyField&&userArr?.[edit?tempIndex:index]?.every((item)=>item.isChecked===false)}
                                                                        edit={edit}
                                                                        isOrgOpen={isOpen}
                                                                        editData={result?.data}
                                                                        isOpen={isSubdivOpen}
                                                                        setisOpen={setIsSubdivOpen}
                                                                    />
                                                            

                                                                </div>
                                                            </div>
                                                            <div className="w-1/3 px-[18px] mb-[35px] flex gap-10">
                                                                {selectedOrganizationName?.length > 1 ? (
                                                                    // If there are multiple indexes
                                                                    <>
                                                                        {index !== 0 && (
                                                                            // Delete icon for all indexes except the first one
                                                                            <div className="relative">
                                                                                <button 
                                                                                    onClick={() => 
                                                                                        edit 
                                                                                            ? handleRemoveOrgField(tempIndex, field?.orgIndex) 
                                                                                            : handleRemoveOrgField(index)
                                                                                    } 
                                                                                    className="pt-9 add_case"
                                                                                >
                                                                                    <span>
                                                                                        <img loading="lazy" decoding="async" src="/images/deleteicon-pink.svg" alt="delete-icon" />
                                                                                    </span>
                                                                                </button>
                                                                                <p className="bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_case_text opacity-0">
                                                                                    Delete
                                                                                </p>
                                                                            </div>
                                                                        )}

                                                                        {index === 0 && (
                                                                            // Add delete icon for the first index only if there are multiple indexes
                                                                            <div className="relative">
                                                                                <button 
                                                                                    onClick={() => 
                                                                                        edit 
                                                                                            ? handleRemoveOrgField(tempIndex, field?.orgIndex) 
                                                                                            : handleRemoveOrgField(index)
                                                                                    } 
                                                                                    className="pt-9 add_case"
                                                                                >
                                                                                    <span>
                                                                                        <img loading="lazy" decoding="async" src="/images/deleteicon-pink.svg" alt="delete-icon" />
                                                                                    </span>
                                                                                </button>
                                                                                <p className="bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_case_text opacity-0">
                                                                                    Delete
                                                                                </p>
                                                                            </div>
                                                                        )}

                                                                        {/* Add icon for the last index */}
                                                                        {index === selectedOrganizationName.length - 1 && (
                                                                            <div className="relative">
                                                                                <button 
                                                                                    onClick={handleAddOrgField} 
                                                                                    type="button" 
                                                                                    className="pt-9 add_case"
                                                                                >
                                                                                    <span>
                                                                                        <img loading="lazy" decoding="async" src="/images/add-plus-red.svg" alt="add-icon" />
                                                                                    </span>
                                                                                </button>
                                                                                <p className="bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_case_text opacity-0">
                                                                                    Add
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    // If there is only one index
                                                                    <div className="relative">
                                                                        <button 
                                                                            onClick={handleAddOrgField} 
                                                                            type="button" 
                                                                            className="pt-9 add_case"
                                                                        >
                                                                            <span>
                                                                                <img loading="lazy" decoding="async" src="/images/add-plus-red.svg" alt="add-icon" />
                                                                            </span>
                                                                        </button>
                                                                        <p className="bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_case_text opacity-0">
                                                                            Add
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </Fragment>)})}
                                                </div>
                                            </div>
                                            
                                        </div>
                                        {!addUserDetails.admin&&items?.length>=10&&isLoading&&edit&&(!(items?.[items?.length-1]?.orgIndex===selectedOrganizationName?.[selectedOrganizationName?.length-1]?.orgIndex))&&<div className="flex justify-center"><BeatLoader color='#972E4C'/></div>}
                                    </div>
                                  
                                </div> 
                                <div className='flex justify-end pr-5'>
                                    <button type='button'
                                        id="cancel"
                                        onClick={handleClosebotton}
                                        className={` px-4 py-2.5 mr-5 text-lg font-semibold  text-[#972E4C] border border-[#972E4C] rounded-[16px] mt-2.5 xl:w-[148px] w-[130px]
                                            bg-[#fff] hover:bg-[#fff] focus:bg-[#fff]`}>
                                        {"Cancel"}
                                    </button>
                                    <button type='button'
                                        id="update"
                                        onClick={()=>handleSubmit()}
                                        className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                        {edit?"Update":"Submit"}
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
          
                {(confirmationState||confirmationStateCancel) &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                              
                                handleOnCLickActivate={handleClickActivate}
                                handleClose={confirmationState?()=>{setConfirmationState(false)}:()=>{setConfirmationStateCancel(false)}}
                                data-testid="confirm-btn"
                                disabled={loading}
                                tittle={confirmationStateCancel?'Cancel':`${edit?'Update':'Add'} ${addUserDetails?.admin?'Admin':'Corporate'} User`}
                                message={confirmationState?`Are you sure you want to ${edit?'update this':'add this'} ${addUserDetails?.admin?'admin':'corporate'} user?`:'Are you sure you want to cancel the changes?'}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}

                            />
                        }
                    />
                }
                {confirmationStateStatus && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                loadingActivation={loadingStatus}
                                setEmptyField={setEmptyArea}
                                disabled={loadingStatus}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                tittle= {statusToggle?'Activate':'Deactivate'}
                                message = {`Are you sure you want to ${statusToggle? 'activate' : 'deactivate'} this ${addUserDetails.admin ? 'admin' : 'corporate'}   user?`}
                                textMessage = {statusToggle===false?false:true}
                                buttonName = {statusToggle?'Activate':'Deactivate'}
                            />
                        }
                    /> 
                }
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
            </div>
        </>
    )}
